import BaseInputError from 'components/generics/inputs/BaseInputError';
import { InputHTMLAttributes } from 'react';
import inputClasses from '../index.module.scss';

const DEFAULT_PLACEHOLDER = 'John Smith';

interface FullNameInputProps extends InputHTMLAttributes<HTMLInputElement> {
  noBorder?: boolean;
  errorMessage?: string;
  inputClassName?: string;
  placeholderClass?: string;
  withPlaceHolderTransition?: boolean;
  label?: string;
}

const FullNameInput = ({
  label,
  errorMessage,
  noBorder,
  inputClassName,
  placeholderClass,
  withPlaceHolderTransition,
  ...props
}: FullNameInputProps) => {
  return (
    <div>
      <label className={inputClasses.label}>{label}</label>
      <BaseInputError
        autoComplete={'full-name'}
        mask={''}
        maskChar={''}
        placeholder={DEFAULT_PLACEHOLDER}
        errorMessage={errorMessage}
        noBorder={noBorder}
        placeholderClass={placeholderClass}
        inputClassName={inputClassName}
        withPlaceHolderTransition={withPlaceHolderTransition}
        {...props}
      />
    </div>
  );
};

export default FullNameInput;
